import { DecoratorNode, SerializedLexicalNode, Spread } from 'lexical';
import * as React from 'react';
import LocalizationIcon from 'assets/icons/translation-needed.svg';
import { Tip } from '../../../../../../components/uikit/Tip.tsx';
import { useScopedTranslation } from '../../../../../../application/localization/useScopedTranslation.ts';
import styles from './localizable.module.scss';

const NODE_TYPE = 'localization-node';

type SerializedLocalizationNode = Spread<
  {
    type: typeof NODE_TYPE;
    version: 1;
  },
  SerializedLexicalNode
>;

const LocalizationComponent = () => {
  const i18n = useScopedTranslation('Page.PageDesigner');

  return (
    <Tip
      tooltipText={i18n.t('translation_needed')}
      customImage={LocalizationIcon}
      className={styles.localizationTooltip}
      tooltipClassName={styles.marginLeft8}
    />
  );
};

export class LocalizationNode extends DecoratorNode<React.ReactNode> {
  static getType(): string {
    return NODE_TYPE;
  }

  static clone(node: LocalizationNode): LocalizationNode {
    return new LocalizationNode(node.__key);
  }

  static importJSON(
    serializedNode: SerializedLocalizationNode,
  ): LocalizationNode {
    return new LocalizationNode();
  }

  exportJSON(): SerializedLocalizationNode {
    return {
      type: NODE_TYPE,
      version: 1,
    };
  }

  static importDOM(): null {
    return null;
  }

  createDOM(): HTMLElement {
    const span = document.createElement('span');
    span.classList.add('translationIconDisplayNone');
    return span;
  }

  updateDOM(): false {
    return false;
  }

  decorate() {
    return <LocalizationComponent />;
  }
}

export function $createLocalizationNode(): LocalizationNode {
  return new LocalizationNode();
}

export function $isLocalizationNode(node: unknown): node is LocalizationNode {
  return node instanceof LocalizationNode;
}
